const state = {
    profitLossItem: null,
    statementItem: null,
    viewBetsItem:null,
    selectedMatch:null
};
const getters = {
    profitLossItem: state => state?.profitLossItem,
    statementItem: state => state?.statementItem,
    viewBetsItem: state => state?.viewBetsItem,
    selectedMatch: state => state?.selectedMatch,
};
const actions = {
    setProfitLossItem({ commit }, profitLossItem) {
        commit('setProfitLossItem', profitLossItem);
    },
    setStatementItem({ commit }, statementItem) {
        commit('setStatementItem', statementItem);
    },
    setViewBetsItem({ commit }, viewBetsItem) {
        commit('setViewBetsItem', viewBetsItem);
    },
    setSelectedMatch({ commit }, selectedMatch) {
        commit('setSelectedMatch', selectedMatch);
    },
};
const mutations = {
    setProfitLossItem(state, profitLossItem) {
        state.profitLossItem = profitLossItem;
    },
    setStatementItem(state, statementItem) {
        state.statementItem = statementItem;
    },
    setViewBetsItem(state, viewBetsItem) {
        state.viewBetsItem = viewBetsItem;
    },
    setSelectedMatch(state, selectedMatch) {
        state.selectedMatch = selectedMatch;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};